import BaseService from "../../base/base_service";
import PlayerMessagesFactory from "./player_messages_factory";

class PlayerMessagesService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'PlayerMessagesService';

    _activeMessageSource;

    _source = null;
    _sourceInitParams = null;



    init(params) {
        super.init(params);
        if (params) {
            this._source = params.source;
            this._sourceInitParams = {
                MainProxy: params.MainProxy,
                Firebase: params.Firebase
            };
            this._dependenciesFactory = params.dependenciesFactory || PlayerMessagesFactory.create();
        }
    }

    doAsyncJobs() {
        this._activateMessagesSourceService();
        return Promise.resolve();
    }

    get isConnected() {
        if(!this._activeMessageSource) {
            return false;
        }

        if(!this.serviceFactory.userService().isAuthorized) {
            return false;
        }

        return this._activeMessageSource.isConnected;
    }

    _activateMessagesSourceService() {
        this._activeMessageSource = this._dependenciesFactory.createMessageSourceComponent(this._source, this._sourceInitParams, {serviceFactory: this.serviceFactory})
    }

    getClientPlatformVersion() {
        return this._activeMessageSource && this._activeMessageSource.getClientPlatformVersion();
    }

    getMessageStrategy() {
        return this._activeMessageSource;
    }


}

export default  PlayerMessagesService;